import React from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import { pieArcLabelClasses } from '@mui/x-charts';
import { cyan } from '@mui/material/colors';
import { Box, Typography, Stack } from '@mui/joy';
import { formatPrc } from '../utils';

const cyanPalette = [900, 800, 700, 600, 'A700', 500, 400, 300, 200, 100, 'A400', 'A200', 'A100'].map((k) => { return cyan[k] });
export const PieChartWithLegend = ({ data, colors = cyanPalette, abs = false }) => {
    return (
        <Box display={'flex'} gap={2} alignItems={{ xs: 'flex-start', sm: 'center' }} width={'fit-content'} flexDirection={{ xs: 'column', sm: 'row' }}>
            <PieChart
                colors={colors}
                slotProps={{
                    itemContent: {
                        sx: (theme) => ({
                            backgroundColor: 'white',
                            ...theme.applyStyles('dark', {
                                backgroundColor: 'black',
                            }),
                        }),
                    },
                    legend: {
                        hidden: true,
                    },
                }}
                series={[
                    {
                        arcLabel: (row) => `${formatPrc(row.value)}`,
                        arcLabelMinAngle: 35,
                        arcLabelRadius: '60%',
                        cx: 100,
                        data: data.map((row) => {
                            const count = abs ? ` (${row.count})` : '';
                            let label = `${row.label} - ${formatPrc(row.prc) + count}`
                            return { label, value: row.prc, cnt: row.count };
                        }),
                        valueFormatter: () => '',
                    },
                ]}
                width={300}
                height={200}
                sx={{ [`& .${pieArcLabelClasses.root}`]: { fill: 'white' } }}
            />
            <Stack spacing={1}>
                {data.map((row, index) => {
                    const count = abs ? ` (${row.count})` : '';
                    return (
                        <Typography key={row.label} level="body-sm" display={'flex'} flexDirection={'row'} alignItems={'center'}>
                            <Box
                                sx={{
                                    width: 20,
                                    height: 20,
                                    borderRadius: 1,
                                    marginRight: 1,
                                    bgcolor: colors[index % colors.length],
                                }}
                            />
                            <Box display={'flex'} alignItems={'center'} gap={1}>
                                {row.legendLabel}
                                {abs && row.count !== undefined && (
                                    <Typography component="span">({row.count})</Typography>
                                )}
                            </Box>
                        </Typography>
                    )
                })}
            </Stack>
        </Box>
    );
};